import script from "./RunRateCard.vue?vue&type=script&setup=true&lang=js"
export * from "./RunRateCard.vue?vue&type=script&setup=true&lang=js"

import "./RunRateCard.vue?vue&type=style&index=0&id=f4b8fb5e&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-f4b8fb5e"]])

export default __exports__